module.exports = __webpack_public_path__ + "static/media/comparing-loader.3dbe0e8c.gif";